import { useRef, useState } from "react";
import {
  ContactContainer,
  EmailButton,
  EmailInput,
  EmailLabel,
  EmailSpan,
  EmailTextArea,
  FormContact,
  InputContainer,
} from "./FormContacEnStyles";
import ReCAPTCHA from "react-google-recaptcha";
import { Loading } from "../HomeBody/HomeBodyStyles";
import scrollTop from "../../utilities/scrollTop";

//https://developers.google.com/recaptcha/intro

const axios = require('axios');

function FormContactEn() {
  const captcha = useRef(null);
  const [email, setEmail] = useState("");
  const [phone, sentPhone] = useState('');

  const [subject, setSubject] = useState("");
  const [body, setBody] = useState("");
  const [comment, setComment] = useState('');
  const [spinner, setSpinner] = useState(false);
  
  scrollTop();



  const submitEmail = (e) => {

    
    e.preventDefault();
        setSpinner(true);

     scrollTop();
     if (captcha.current.getValue() === '') {
        setComment('Please check captcha')
        return
     
    }

    setComment('');

    const data = {
      email: email,
      phone: phone,
      subject: subject,
      text: body
    
    };

    const config = {
      method: 'post',
      url: `${process.env.REACT_APP_BACKEND_URL}/api/email`,
      headers: { },
      data : data
    };
    
 
   
    axios(config)
    .then(function (response) {
      setEmail('');
      sentPhone(''); 
      setSubject('');
      setBody('');
      setComment('');
      setTimeout(() => {
        setSpinner(false)
        
      }, 1000);
      
      
      
     return
    })
    .catch(function (error) {
     
      setComment(`Couldn't send email`);

      setSpinner(false)
    return
    })
      
    
  };

  


  const handleCaptcha = (e) => {
   
     if (captcha.current.getValue()) {
       setComment('')
     
    }


  }





  if (spinner === true) {
     return (
    <>
            <Loading load={true}>
            <div>
              <div className="ring">
                Sent
                <span id='span'></span>
              </div>
            </div>
          </Loading>
  

              </>
  );
  } 


  return (

    <>       
    <ContactContainer className="fade-in">
  
   
        
          <FormContact onSubmit={submitEmail}>
          <InputContainer>
            <EmailLabel>
             Mail address: <EmailSpan></EmailSpan>
            </EmailLabel>
  
            <EmailInput
              name="email"
              placeholder="Your email address please"
              type='email'
              required
              value={email}
              onChange={(e)=> setEmail(e.target.value)}
              />
          </InputContainer>

          <InputContainer>
            <EmailLabel>
             Phone: <EmailSpan></EmailSpan>
            </EmailLabel>
  
            <EmailInput
              name="phone"
              placeholder="Your phone number please"
              type='tel'
              required
              value={phone}
              onChange={(e)=> sentPhone(e.target.value)}
              />
          </InputContainer>
  
  
          <InputContainer>
            <EmailLabel>Subject:</EmailLabel>
            <EmailInput   
            name="subject"
            onChange={(e)=> setSubject(e.target.value)}
            defaultValue={subject}
            placeholder="Write a subject (optional)."
            required
            />
          </InputContainer>
  
          <InputContainer>
            <EmailLabel></EmailLabel>
            <EmailTextArea 
            name="message"
            onChange={(e)=> setBody(e.target.value)}
            defaultValue={body}
            placeholder="Write a message."
            required
            />
          </InputContainer>

          <div className="recaptcha">
            <span style={{fontSize: '20px'}}>{comment}</span>
            <ReCAPTCHA 
            sitekey="6Le_YiQkAAAAAFk-AwpcKeGOkOB5xGARwHG9DwGN" 
            onChange={handleCaptcha}
            ref={captcha}
            onClick={()=> setComment('')}
            size="compact" 
            >
            </ReCAPTCHA>
          </div>
  
          <InputContainer>
            <EmailButton >Send</EmailButton>
          </InputContainer>
        </FormContact>
      
     
    </ContactContainer>

              </>

)
  



 
}

export default FormContactEn;
